var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketReach(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.69 57.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.84,8.65c-4.78,0-8.65,3.87-8.65,8.65s3.87,8.65,8.65,8.65,8.65-3.87,8.65-8.65-3.88-8.65-8.65-8.65m.42,23.08c-6.56,0-12.88,2.48-17.66,6.97,3.78,6.21,10.44,10.1,17.7,10.34,7.27-.23,13.93-4.12,17.71-10.34-4.79-4.49-11.11-6.98-17.68-6.97h-.07Zm-.42,25.96C12.91,57.69,0,44.78,0,28.84S12.91,0,28.84,0s28.84,12.91,28.84,28.84c-.02,15.92-12.92,28.83-28.84,28.84",
    style: {
      fill: "#c42032"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketReach);
export default __webpack_public_path__ + "static/media/MarketReach.f53f0a344d63de5b58514ccadbd7feb4.svg";
export { ForwardRef as ReactComponent };